module.exports = __webpack_public_path__ + "static/atp-logo-2136ea6e75a3e787b3cf80d990897614.png";